const normalizeUSOpenExclusiveEligibility = ({
  reservations = [],
  isCenturionEligible,
  isPlatinumEligible,
  centurionExclusiveId,
  platinumExclusiveId,
}) => reservations.map((servicePeriod) => ({
  ...servicePeriod,
  available: (servicePeriod.available || [])
    .filter((slot) => [centurionExclusiveId, platinumExclusiveId].includes(slot.exclusiveId))
    .map((slot) => {
      if (slot.exclusiveId === centurionExclusiveId) {
        return { ...slot, isEligible: !!isCenturionEligible };
      }

      if (slot.exclusiveId === platinumExclusiveId) {
        return { ...slot, isEligible: !!isPlatinumEligible };
      }

      return slot;
    }),
}));

export default normalizeUSOpenExclusiveEligibility;
